import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UListBoxComponent } from './u-list-box.component';
import { MatListModule } from '@angular/material/list';

@NgModule({
  declarations: [UListBoxComponent],
  imports: [CommonModule, MatListModule, FormsModule],
  exports: [UListBoxComponent],
})
export class UListBoxModule { }
